import { type FC } from 'react';

import { Button } from '@skillarea/lib-frontend';
import { Title, TextBlock } from '@skillarea/lib-frontend';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import styles from '../MatchmakingModal.module.scss';

export interface IDrawScreenProps {
  isFreePlay?: boolean;
  onFindNewOpponent: () => void;
  onRematch: () => void;
}

export const DrawScreen: FC<IDrawScreenProps> = ({
  isFreePlay = false,
  onFindNewOpponent,
  onRematch,
}) => {
  const { t } = useTranslation('matchmaking');

  return (
    <div className={cx(styles.screen, styles.drawScreen)}>
      <div className={cx(styles.centered, styles.resultScreen)}>
        <div className={styles.resultIcon}>
          <span aria-hidden className={styles.emoji}>
            🤝
          </span>
        </div>

        <TextBlock className={styles.resultText} size="l">
          {t('result.draw.subtitle')}
        </TextBlock>

        <Title className={styles.resultTitle} color="contrast" size="l">
          {t('result.draw.title')}
        </Title>
      </div>

      <div className={styles.footer}>
        <div className={styles.actionButtons}>
          {isFreePlay ? (
            <Button
              className={styles.actionButton}
              color="accent"
              name={t('result.playAgain')}
              onClick={onFindNewOpponent}
              size="s"
              variant="filled"
            >
              {t('result.playAgain')}
            </Button>
          ) : (
            <>
              <Button
                className={styles.actionButton}
                color="accent"
                name={t('result.findNewOpponent')}
                onClick={onFindNewOpponent}
                size="s"
                variant="filled"
              >
                {t('result.findNewOpponent')}
              </Button>
              <Button
                className={styles.actionButton}
                color="primary"
                name={t('result.rematch')}
                onClick={onRematch}
                size="s"
                variant="filled"
              >
                {t('result.rematch')}
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
